// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24bO1","col":"styles_col__zCUKv"};